RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    const companySets = state.companySets = new Backbone.Collection();

    // todo: these should probably be in constant style (e.g., NONE)
    companySets.none = null;
    companySets.focus = '___internal___focus';
    companySets.onlyCompany = '__internal__company_';

    const staticCompanySetOrder = [companySets.none, companySets.focus];

    companySets.add = function () {
        const me = this;

        const ret = Backbone.Collection.prototype.add.apply(me, arguments);
        companySets.trigger('companySetsChanged');

        return ret;
    };

    // NOTE overwritten b/c get(null) doesn't work
    companySets.get = function (id) {
        const me = this;

        if (id === companySets.none) {
            return _.find(me.models, {
                id: companySets.none
            });
        }

        const companySet = Backbone.Collection.prototype.get.apply(me, arguments);
        if (companySet) {
            return companySet;
        }

        return me.findWhere({
            companySetId: id
        });
    };

    /**
     * The sort function for company sets. None is always first, untagged second,
     * otherwise considered alphabetically by lowercase ascending.
     * @param a
     * @param b
     * @returns {number}
     */
    companySets.comparator = function (a, b) {

        const aId = a.get('id');
        const bId = b.get('id');

        const aIndex = _.indexOf(staticCompanySetOrder, aId);
        const bIndex = _.indexOf(staticCompanySetOrder, bId);

        if (aIndex === -1 && bIndex === -1) {
            return aId.toLowerCase().localeCompare(bId.toLowerCase());
        }

        if (aIndex === -1) {
            return 1;
        }

        if (bIndex === -1) {
            return -1;
        }

        return aIndex - bIndex;
    };

    companySets.getUserCompanySets = function () {
        const me = this;
        const internalCompanySetIds = [
            state.companySets.none,
            state.companySets.onlyCompany
        ];

        return me.reject(function (companySet) {
            return _.includes(internalCompanySetIds, companySet.id);
        });
    };

    companySets.addCompanySetToCompanies = function (companySetName, companies, callback) {
        const data = {
            companySetName: companySetName,
            companyIds: _.map(companies, 'id')
        };

        const landscapeId = RivalIQ.state.view.get('landscapeId');
        const url = `/api/landscape/${encodeURIComponent(landscapeId)}/companySets`;

        return $.ajax({
            url: url,
            type: 'POST',
            data: data,
            success: function (result) {

                _.each(companies, function (company) {
                    const companySetNames = company.get('companySetNames');
                    company.set({
                        companySetNames: _.union(companySetNames, [companySetName])
                    });
                });

                if (callback) {
                    callback(null, result);
                }
                const companySet = companySets.get(companySetName);
                if (companySet) {
                    companySets.trigger('companySetsChanged', companySet.get('companySetId'));
                }
            },
            error: function (error) {
                if (callback) {
                    callback(error);
                }
            }
        });
    };

    companySets.removeCompanySetFromCompanies = function (companySetName, companies, callback) {
        const data = {
            companySetName: companySetName,
            companyIds: _.map(companies, 'id')
        };

        const landscapeId = RivalIQ.state.view.get('landscapeId');
        const url = `/api/landscape/${encodeURIComponent(landscapeId)}/companySets`;

        return $.ajax({
            url: url,
            type: 'DELETE',
            data: data,
            success: function (result) {
                _.each(companies, function (company) {
                    const companySetNames = company.get('companySetNames');
                    company.set({
                        companySetNames: _.difference(companySetNames, [companySetName])
                    });
                });

                if (callback) {
                    callback(null, result);
                }

                const companySet = companySets.get(companySetName);
                if (companySet) {
                    companySets.trigger('companySetsChanged', companySet.get('companySetId'));
                }
            },
            error: function (error) {
                if (callback) {
                    callback(error);
                }
            }
        });
    };

    companySets.deleteCompanySet = function (companySetName) {
        const companySet = companySets.get(companySetName);

        if (!companySet) {
            // it's possible that the company set was never saved in the first place, so just return if it's not there.
            return $.when();
        }

        companySets.remove(companySet);
        const landscapeId = RivalIQ.state.view.get('landscapeId');
        const url = `/api/landscape/${encodeURIComponent(landscapeId)}/companySets/${companySet.get('companySetId')}`;

        return $.ajax({
            url: url,
            type: 'DELETE',
            success: function () {
                // clean up the companies collection to remove the company set
                RivalIQ.state.landscape.get('companies').each(function (company) {
                    const companySetNames = company.get('companySetNames');
                    company.set({
                        companySetNames: _.difference(companySetNames, [companySet.get('name')])
                    });
                });

                // if we've deleted the company set we currently have selected, default back to null.

                if (RivalIQ.state.view.get('companySetDescriptor') === companySet.get('companySetId')) {
                    RivalIQ.state.view.set({
                        companySetDescriptor: RivalIQ.state.companySets.none
                    });
                }
                companySets.trigger('companySetsChanged', companySet.get('companySetId'));
            }
        });
    };

    function buildCompanySetsArray(allCompanies, userCompanySets) {
        const internalCompanySets = [
            {
                id: state.companySets.none,
                name: 'All Companies'
            }
        ];

        const companySets = _.map(userCompanySets, function (companySet) {

            const unescaped = _.unescape(companySet.description);
            return {
                id: unescaped,
                name: unescaped,
                isUserCompanySet: true,
                companySetId: companySet.id
            };
        });

        return internalCompanySets.concat(companySets);
    }

    function initializeCompanySetsFromProperties(properties) {
        // Handle landscapes with no companies
        const data = buildCompanySetsArray(properties.activeLandscapeCompanies, properties.activeLandscapeCompanySets);

        companySets.reset(data, {
            silent: true
        });
    }

    (function () {

        let hasInitialized = false;

        companySets.initialize = function (properties) {

            if (hasInitialized) {

                throw 'not supported: companySets cannot be initialized more than once.';
            }

            initializeCompanySetsFromProperties(properties);

            hasInitialized = true;
        };

    }());
});
